import { Typography } from "@mui/material";
import TooltipForForm from "./TooltipForForm";

function getItems(obj: { [key: string]: any }, items: any[]) {
  Object.keys(obj).forEach((k, i) => {
    if (typeof obj[k] === "object") {
      getItems(obj[k], items);
    } else {
      try {
        const i = JSON.parse(obj[k]);
        getItems(i, items);
      } catch (error) {
        items.push(
          <div
            className="margin-b-small"
            style={{ display: "flex" }}
            key={`${k}_${i}`}
          >
            <div style={{ width: 200 }}>{k}</div>
            <div style={{ width: 200 }}>{obj[k]}</div>
          </div>,
        );
      }
    }
  });
}

export function getItemsNode(text: string) {
  let ele: any;
  try {
    const obj = JSON.parse(text);
    const items: any[] = [];
    getItems(obj, items);
    ele = <div>{items}</div>;
    return ele;
  } catch (error) {
    console.error("parse failed:", error);
    return text;
  }
}

export default function EllipsisText(props: {
  text: string;
  width?: number;
  showInObject?: boolean;
}) {
  const { text, showInObject, width } = props;
  return (
    <TooltipForForm title={showInObject ? getItemsNode(text) : text}>
      <Typography
        sx={{ width: width || 80 }}
        className="ellipsis-text"
        noWrap
        variant="body1"
        component="div"
      >
        {text}
      </Typography>
    </TooltipForForm>
  );
}
